import type { FC } from 'react';

import { cn } from '@repo/utils/common';

import { useScrollHideState } from '@/client/hooks/scroll.hooks';

import { AppBar } from '@/components/toolbar/AppBar';
import { Header } from '@/components/toolbar/Header';

/**
 * Fixed two-tier top chrome: a gray utility AppBar over a charcoal Header.
 * On mobile the bars slide out of view on scroll-down and back on scroll-up
 * (driven by {@link useScrollHideState}); desktop bars stay visible.
 */
export const Toolbar: FC = () => {
  const hidden = useScrollHideState();

  return (
    <div
      // While a modal Radix layer (dropdown/popover) is open, react-remove-scroll
      // strips the body scrollbar and pads the body by its width. This fixed bar
      // is outside body flow, so without the same compensation it re-centers and
      // visibly jumps. `--removed-body-scroll-bar-size` is set only while locked.
      className={cn(
        'fixed inset-x-0 top-0 z-50 pr-(--removed-body-scroll-bar-size,0px)',
        'shadow-lg transition-transform duration-300',
        hidden ? '-translate-y-full' : 'translate-y-0',
      )}
    >
      <AppBar />
      <Header />
    </div>
  );
};
